import { PrimitiveType } from './workflow.type';

/**
 * Common validation concepts for StatefulValue, Field, Card, and Page
 */
export abstract class ValidationBase {
  /**
   * A persistent object to store validation IDs that failed
   */
  private readonly failedValidationsCache: string[] = [];

  /**
   * if validation name exists return list of its argument
   * @param fnName name of the validation
   */
  public abstract hasValidation(fnName: string): PrimitiveType[];

  /**
   * logic for Trigger revalidation
   */
  public abstract revalidate(): string[];

  /**
   * Array of distinct failed validation IDs. Will always provide at least an empty array
   */
  public get failedValidations(): string[] {
    const distinct = (value: string, index: number, self: string[]) => self.indexOf(value) === index;
    return this.revalidate().filter(distinct);
  }

  /**
   * Shorthand to check if there are validation fails. Checks if `failedValidations.length` is zero
   */
  public get valid(): boolean {
    return !this.revalidate().length;
  }

  /**
   * Propagate failed validations from fixed array ref
   * @param validations failed validation names
   */
  protected spreadValidation(...validations: string[][]): string[] {
    this.failedValidationsCache.length = 0;
    validations.forEach((validationResult) => {
      this.failedValidationsCache.push(...validationResult);
    });
    return this.failedValidationsCache;
  }
}
